/* RolePicker.tsx generated by @compiled/babel-plugin v0.37.1 */
import { ax, ix } from "@compiled/react/runtime";
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._1pbyni7l%7Bz-index%3A600%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._4cvx1v1w%3Ahover%7Bborder-color%3Avar(--ds-border-focused%2C%234688ec)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._bfhki8nm%7Bbackground-color%3Avar(--ds-background-neutral%2C%230515240f)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._1h6d1v1w%7Bborder-color%3Avar(--ds-border-focused%2C%234688ec)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._irr315s3%3Ahover%7Bbackground-color%3Avar(--ds-background-selected%2C%23e9f2fe)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._bfhk15s3%7Bbackground-color%3Avar(--ds-background-selected%2C%23e9f2fe)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._irr3plhp%3Ahover%7Bbackground-color%3Avar(--ds-background-neutral-hovered%2C%230b120e24)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._4cvx1j28%3Ahover%7Bborder-color%3Atransparent%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._bozgutpp%7Bpadding-inline-start%3Avar(--ds-space-150%2C9pt)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._4t3ickbl%7Bheight%3A3pc%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._bfhk1j9a%7Bbackground-color%3Avar(--ds-background-input%2C%23fff)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._80omtlke%7Bcursor%3Apointer%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._1h6d1l7x%7Bborder-color%3Avar(--ds-border%2C%230b120e24)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._2rko12b0%7Bborder-radius%3Avar(--ds-radius-small%2C4px)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._syaz1rpy%7Bcolor%3Avar(--ds-text-subtlest%2C%236b6e76)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._1e0c1ule%7Bdisplay%3Ablock%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._6rth1b66%7Bmargin-block-end%3Avar(--ds-space-050%2C4px)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._1pfhze3t%7Bmargin-block-start%3Avar(--ds-space-0%2C0)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._k48p1pd9%7Bfont-weight%3Avar(--ds-font-weight-semibold%2C600)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._11c8wadc%7Bfont%3Avar(--ds-font-body-small%2Cnormal%20400%209pt%2F1pc%20%22Atlassian%20Sans%22%2Cui-sans-serif%2C-apple-system%2CBlinkMacSystemFont%2C%22Segoe%20UI%22%2CUbuntu%2C%22Helvetica%20Neue%22%2Csans-serif)%7D");
import React, { useCallback, useEffect, useMemo } from 'react';
import { getDocument } from '@atlaskit/browser-apis';
import { ErrorMessage } from '@atlaskit/form';
import { Box, Flex, Text } from '@atlaskit/primitives/compiled';
import type { MenuPortalProps, GroupBase } from '@atlaskit/react-select';
import Suspense from '@atlaskit/react-ufo/suspense';
import Select, { type FormatOptionLabelMeta, components, ControlProps } from '@atlaskit/select';
import { ApplicationEdition } from '@atlassian/invite-people/types';
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { cx } from '@compiled/react';
import { useIntl, FormattedMessage } from 'react-intl';
import { graphql, useFragment, usePreloadedQuery, type PreloadedQuery } from 'react-relay';
import { useAnalytics } from '@townsquare/analytics';
import { ErrorBoundary } from '@townsquare/monitoring/error-boundary';
import { JiraRoleDetail, JiraSpaceOption, RoleSelectOption } from '../../types/SpaceInputTypes';
import { getDefaultRole, getRoleAsOption } from '../../utils/roleUtils';
import { Skeleton } from './Skeleton';
import type { RolePickerWithPermissionQuery } from './__generated__/RolePickerWithPermissionQuery.graphql';
import type { RolePicker_data$key } from './__generated__/RolePicker_data.graphql';
import { rolePickerMessages } from './messages';
const controlStyles = {
  root: "_2rko12b0 _1h6d1l7x _80omtlke _bfhk1j9a _4t3ickbl _bozgutpp _4cvx1j28 _irr3plhp",
  menuIsOpen: "_bfhk15s3 _irr315s3",
  focused: "_1h6d1v1w _bfhki8nm _4cvx1v1w",
  menuPortal: "_1pbyni7l"
};
const defaultFormatRoleOptionLabel = (option: RoleSelectOption, {
  context
}: FormatOptionLabelMeta<RoleSelectOption>) => {
  if (context === 'menu') {
    return <Flex direction="column">
				{option.label}
				{option.role.description ? <Text size="small" color="color.text.subtlest">
						{option.role.description}
					</Text> : null}
			</Flex>;
  }
  return option.label;
};
const RolePickerWrapper = ({
  children
}: {
  children: React.ReactNode;
}) => {
  const {
    formatMessage
  } = useIntl();
  return <Box>
			<label id="role-picker-input-label" className={ax(["_11c8wadc _k48p1pd9 _1pfhze3t _6rth1b66 _1e0c1ule _syaz1rpy"])}>
				{formatMessage(rolePickerMessages.roleLabel)}
			</label>
			{children}
		</Box>;
};
type RolePickerWithPermissionProps = {
  permissionAndRolesQueryRef: PreloadedQuery<RolePickerWithPermissionQuery>;
  setSelectedRole: (role: JiraRoleDetail | undefined) => void;
  selectedRole: JiraRoleDetail | undefined;
  appEdition: ApplicationEdition;
  selectedSpace: JiraSpaceOption;
  isGlobalAdmin: boolean;
};
type RolePickerProps = Omit<RolePickerWithPermissionProps, 'permissionAndRolesQueryRef' | 'isGlobalAdmin'> & {
  permissionAndRolesQueryRef: PreloadedQuery<RolePickerWithPermissionQuery> | null;
  queryRef: RolePicker_data$key;
};
export const RolePicker = ({
  permissionAndRolesQueryRef,
  queryRef,
  ...props
}: RolePickerProps) => {
  const globalPermData = useFragment(graphql`
			fragment RolePicker_data on Query @argumentDefinitions(cloudId: { type: "ID!" }) {
				jira {
					isGlobalAdmin: hasGlobalPermission(cloudId: $cloudId, key: ADMINISTER) @optIn(to: "JiraHasGlobalPermission")
				}
			}
		`, queryRef);
  const isGlobalAdmin = globalPermData?.jira?.isGlobalAdmin ?? false;
  if (!permissionAndRolesQueryRef) {
    return null;
  }
  return <ErrorBoundary fallback={<RolePickerWrapper>
					<ErrorMessage>
						<FormattedMessage {...rolePickerMessages.errorFetchRolesMessage} />
					</ErrorMessage>
				</RolePickerWrapper>}>
			<Suspense interactionName="role-picker-loading" fallback={<Skeleton labelWidth="30%" testId="teams.invite-user-modal.role-picker.loading-skeleton" />}>
				<RolePickerWithPermission permissionAndRolesQueryRef={permissionAndRolesQueryRef} isGlobalAdmin={isGlobalAdmin} {...props} />
			</Suspense>
		</ErrorBoundary>;
};
const RolePickerWithPermission = ({
  permissionAndRolesQueryRef,
  selectedRole,
  setSelectedRole,
  appEdition,
  selectedSpace,
  isGlobalAdmin
}: RolePickerWithPermissionProps) => {
  const analytics = useAnalytics();
  const data = usePreloadedQuery<RolePickerWithPermissionQuery>(graphql`
			query RolePickerWithPermissionQuery($cloudId: ID!, $projectKey: String!) {
				jira {
					isProjectAdmin: hasProjectPermission(
						cloudId: $cloudId
						permission: ADMINISTER_PROJECTS
						projectKey: $projectKey
					) @optIn(to: "JiraHasProjectPermissionQuery")

					jiraProjectByKey(cloudId: $cloudId, key: $projectKey) {
						roles {
							edges {
								node {
									name
									isDefaultRole
									roleId
									isAdmin
									isRoleConfigurable
									translatedName
									description
								}
							}
						}
					}
				}
			}
		`, permissionAndRolesQueryRef);
  const isProjectAdmin = data?.jira?.isProjectAdmin;
  const roles: JiraRoleDetail[] = useMemo(() => {
    if (!isProjectAdmin && !isGlobalAdmin) {
      return [];
    }
    const edges = data?.jira?.jiraProjectByKey?.roles?.edges ?? [];
    return edges.map(edge => edge?.node).filter((node): node is NonNullable<typeof node> => node != null).map(node => ({
      id: parseInt(node.roleId, 10),
      name: node.name ?? '',
      description: node.description ?? '',
      default: node.isDefaultRole ?? false,
      admin: node.isAdmin ?? false,
      roleConfigurable: node.isRoleConfigurable ?? false,
      translatedName: node.translatedName ?? ''
    }));
  }, [data, isProjectAdmin, isGlobalAdmin]);
  const {
    availableRoles,
    options
  } = useMemo(() => {
    const filtered = appEdition === 'FREE_EDITION' ? roles.filter(role => role.admin) : roles;
    return {
      availableRoles: filtered,
      options: filtered.map(getRoleAsOption)
    };
  }, [roles, appEdition]);
  useEffect(() => {
    void analytics.track('rolePicker', 'loaded', {
      rolesCount: roles.length,
      availableRolesCount: availableRoles.length,
      spaceKey: selectedSpace.key,
      isProjectAdmin,
      isGlobalAdmin,
      noRolesForAdmins: isProjectAdmin || isGlobalAdmin ? availableRoles.length === 0 : undefined
    });
  }, [roles, availableRoles, selectedSpace.key, analytics, isProjectAdmin, isGlobalAdmin]);
  useEffect(() => {
    if (availableRoles.length === 0) {
      if (appEdition === 'FREE_EDITION') {
        void analytics.track('rolePicker', 'freeEditionNoAdminRole', {
          isProjectAdmin,
          isGlobalAdmin,
          appEdition,
          selectedSpaceKey: selectedSpace.key,
          selectedSpaceType: selectedSpace.projectTypeKey,
          selectedSpaceProjectStyle: selectedSpace.projectStyle
        });
      }
      return;
    }
    // Set role based on edition
    const roleToSelect = appEdition === 'FREE_EDITION' ? availableRoles[0] // Free edition: always select first available "admin" role
    : getDefaultRole(availableRoles); // Other editions: use default role logic
    setSelectedRole(roleToSelect);
  }, [availableRoles, appEdition, setSelectedRole, analytics, isProjectAdmin, isGlobalAdmin, selectedSpace]);
  const selectedValue: RoleSelectOption | undefined = useMemo(() => selectedRole ? getRoleAsOption(selectedRole) : undefined, [selectedRole]);
  const onRoleChange = useCallback((option: RoleSelectOption | null) => {
    const role = option?.role;
    setSelectedRole(role);
    void analytics.ui('option', 'selected', {
      selectedRoleId: role?.id,
      spaceKey: selectedSpace.key,
      isProjectAdmin,
      isGlobalAdmin,
      isDefaultRole: role?.default,
      isAdminRole: role?.admin
    }, 'rolePicker');
  }, [setSelectedRole, analytics, selectedSpace, isProjectAdmin, isGlobalAdmin]);
  const renderCustomComponent = useMemo(() => ({
    Control: (props: ControlProps<RoleSelectOption>) => <components.Control {...props} xcss={cx(controlStyles.root, props.isFocused && controlStyles.focused, props.menuIsOpen && controlStyles.menuIsOpen)} />,
    MenuPortal: (props: MenuPortalProps<RoleSelectOption, false, GroupBase<RoleSelectOption>>) => <components.MenuPortal {...props} xcss={controlStyles.menuPortal} />
  }), []);
  if (isGlobalAdmin || isProjectAdmin) {
    if (availableRoles.length > 0) {
      return <RolePickerWrapper>
					<Select components={renderCustomComponent} formatOptionLabel={defaultFormatRoleOptionLabel} isClearable={false} isSearchable={false} isLoading={false} isInvalid={false} isRequired value={selectedValue} options={options} onChange={onRoleChange} fieldId="invite-user-role" id="role-picker-input" labelId="role-picker-input-label" menuPortalTarget={getDocument()?.body} menuPosition="fixed" />
				</RolePickerWrapper>;
    } else {
      return <RolePickerWrapper>
					<ErrorMessage>
						<FormattedMessage {...rolePickerMessages.noRolesMessage} />
					</ErrorMessage>
				</RolePickerWrapper>;
    }
  }
  return null;
};
const labelStyles = null;